<!-- 
/**
 * @author liushuwei
 * @CreateTime 2024.04.29
 */ 
-->

<template>
  <!-- popSvga @click="showSvga = false"-->
  <div
    v-show="showSvga"
    class="popSvga"
    :class="{ 'bg-transparent': isBgTransparent }"
  >
    <div ref="canvas" class="svga"></div>
  </div>
</template>

<script setup lang="ts">
import type { Parser, Player, VideoEntity } from 'svgaplayerweb'
// import { ToastWrapperInstance } from 'vant/lib/toast/types'

const props = defineProps({
  // 是否只播放一次，默认：是
  singlePlay: {
    type: Boolean,
    default: true
  },

  // 是否加载完成后自动播放，默认：是
  loadedPlay: {
    type: Boolean,
    default: true
  },

  // 背景是否透明，默认：否
  isBgTransparent: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['onEnd', 'onStart'])

// SvGA 动画效果
let player: Player | null = null
let parser: Parser | null = null

const showSvga = ref(false)
const canvas = ref<HTMLDivElement | null>(null)

// svga数据   key为id，value为url
const svgaSourceMap: Record<string, VideoEntity> = {}
// 保存已发送过请求的svga，key为id，value为url
const loadMap: Record<string, string> = {}
let currentKey = '' // 当前播放的svgaKey
// let toast: ToastWrapperInstance | null = null
/**
 * 预览svga
 * @param {string} url svga url
 */
const openSvga = (url: string) => {
  if (svgaSourceMap[url]) {
    // toast && toast.close()
    currentKey = url
    if (player) {
      player.setVideoItem(svgaSourceMap[url])
      player.startAnimation()
    }
    showSvga.value = true
  } else {
    // 如果没有还没开始加载，则现在加载
    if (!loadMap[url]) {
      loadSvga(url).then(() => {
        // 如果没有打开其他的svga预览，加载完后，则打开现在这个svga
        if (!showSvga.value && props.loadedPlay) {
          openSvga(url)
        }
      })
    }
    // toast = showToast('Loading...')
  }
}

/**
 * 加载svga
 * @param {string} url svga url
 */
const loadSvga = (url: string) => {
  return new Promise((resolve) => {
    if (!loadMap[url]) {
      loadMap[url] = url
      if (parser) {
        parser.load(
          url,
          (videoItem) => {
            console.log('videoItem', videoItem)
            svgaSourceMap[url] = videoItem
            resolve(url)
          },
          (err) => {
            // FIXME: 线上有些资源其实用的是静态图，导致Sentry报错较多，这里加上加载失败的回调，解决线上报错(incorrect header check)
            console.log('load err', err, url)
          }
        )
      }
    }
  })
}

onMounted(() => {
  if (process.client && canvas.value && window.SVGA) {
    player = new window.SVGA.Player(canvas.value)
    parser = new window.SVGA.Parser()
    if (props.singlePlay) {
      // loops循环次数，默认无限循环
      if (player) {
        player.loops = 1
        player.onFinished(() => {
          showSvga.value = false
          emit('onEnd', currentKey)
        })
        player.onFrame((frame) => {
          if (frame === 1) {
            emit('onStart', currentKey)
          }
        })
      }
    } else {
      if (player) {
        player.onFinished(() => {
          emit('onEnd', currentKey)
        })
        player.onFrame((frame) => {
          if (frame === 1) {
            emit('onStart', currentKey)
          }
        })
      }
    }
  }
})
defineExpose({ canvas, showSvga, loadSvga, openSvga })
</script>

<style lang="scss" scoped>
// popSvga
.popSvga {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba($color: #000000, $alpha: 0.1);
  z-index: 9999;
  .bg-transparent {
    background-color: transparent;
  }

  // svga
  .svga {
    direction: ltr;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    max-width: 100%;
  }
}
</style>
